<template>
  <div id="app">
    <div id="view" :class="viewType">
      <topbar
        v-if="!loginPage"
        @logout="logout"
        @reset-hide-menu="askHideMenu = false"
        :parent-hide-menu="askHideMenu"
        :active-user="activeUser"
        :user-group="userGroup"
        :local="localName"
        :logo="logo"
        :utc="utc"
        :mobile="isMobile()"
        :is-admin="isAdmin"
        :alerts-access="hasAlertsAccess"
      />
      <!-- v-if="!loginPage && !isMobile()" -->
      <side-bar
        :notifServerStatus="notifServerStatus"
        :notifs="notifs"
        :isAdmin="isAdmin"
        :management-access="hasManagementAccess"
        :alerts-access="hasAlertsAccess"
        @show-access-denied-modal="(msg) => openAccessDeniedModal(msg)"
        @hide-access-denied-modal="closeAccessDeniedModal"
      />
      <div
        id="router"
        :class="`${
          warning
            ? 'router-with-general-warning'
            : 'router-without-general-warning'
        }`"
      >
        <router-view
          :key="routerViewKey"
          v-title="`${titleNavBar ? titleNavBar + ' |' : ''} SIGMA`"
          @change-active-user="onChangeActiveUser"
          :management-access="hasManagementAccess"
          :alerts-access="hasAlertsAccess"
          @title-change="(title) => (titleNavBar = title)"
          @hide-menu="askHideMenu = true"
          @show-access-denied-modal="(msg) => openAccessDeniedModal(msg)"
          @hide-access-denied-modal="closeAccessDeniedModal"
          :local="localName"
          :city="city"
          :state="state"
          :utc="utc"
          :mobile="isMobile()"
          :status-cir="cir"
        ></router-view>
      </div>
      <div class="custom-alert">
        <b-alert
          :show="dismissCountDown"
          dismissible
          @dismissed="dismissCountDown = 0"
          @dismiss-count-down="countDownChanged"
          fade
          :variant="alertVariant"
        >
          <h4 v-if="!!alertTitle">{{ alertTitle }}</h4>
          {{ alertMsg }}
        </b-alert>
      </div>
      <general-warning :warning="warning" v-if="!loginPage && !isMobile()" />
      <!--       
      <bottom-bar
        v-if="!loginPage && isMobile()"
        @logout="logout"
        :warning="warning"
        :notif-server-status="notifServerStatus"
        :notifs="notifs"
        :is-admin="isAdmin"
        :alerts-access="hasAlertsAccess"
        @show-access-denied-modal="(msg) => openAccessDeniedModal(msg)"
        @hide-access-denied-modal="closeAccessDeniedModal"
      /> -->
    </div>

    <b-modal
      centered
      ref="dialogWait"
      no-close-on-backdrop
      no-close-on-esc
      size="sm"
      hide-header
      hide-footer
    >
      <div class="center-xs">
        <spinner />
      </div>
    </b-modal>

    <b-modal
      size="lg"
      ref="accessDeniedModal"
      centered
      headerClass="p-2 border-bottom-1"
      footerClass="p-2 border-top-0"
      bodyClass="text-center"
      title="🔒 Acesso negado!"
      ok-title="Fechar"
      ok-variant="success"
      hide-footer
    >
      <div class="title-modal-info">
        Você não tem permissão para acessar esta página.
        <div>
          Entre em contato com a <b>3V3 Tecnologia</b> para obter a permissão
          para a página de {{ accessDeniedMessage }}.
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
// vue router navigation guard
import store from "./store";
import router from "@/router";
import { user } from "@/pages/components/globalstore";
import { cookies } from "@/pages/components/cookies";
// let authorized = users.load()
let authorized = store.getters.authorized;
// Setting permissions on routes cards nav items
// store.dispatch('fetchUserPermissions');

router.beforeEach(async (to, from, next) => {
  store.commit("setLocalUserData");
  authorized = store.getters.authorized;
  // Setting permissions on routes cards nav items
  await store.dispatch("fetchUserPermissions");
  await store.dispatch("updateRoutesPermissions");

  const flatRoutes = getFlatRoutes(store.state.routesPermissions);
  const currentRouteStore = flatRoutes.find(
    (routePerm) => routePerm.routeName == to.name
  );
  const isProtectedRoute = !!currentRouteStore;
  // return next("/");
  const freeRoutes = ["/login", "/news"];
  if (to.path === "/login" && localStorage.getItem("userData")) {
    next("/monitoring");
  }
  if (!authorized && !freeRoutes.includes(to.path)) {
    return next("/login");
  }

  if (isProtectedRoute && !currentRouteStore.isLocked) {
    return next();
  } else if (isProtectedRoute) {
    return next("/monitoring");
  }

  if (!to.matched.length) {
    return next("/404");
  } else if (to.path == "/login" || to.path == "/") {
    return next("/monitoring");
  } else if (to.path.indexOf("/config") > -1 && user.PERMISSION != 1) {
    alert("Você precisa ser ADMINISTRADOR para ter acesso a essa página.");
    return next("/monitoring");
  }

  return next();
});

import { sweep as status, map, session } from "@/api";
// import { isMobile } from "@/pages/components/helpers";
import { mobile } from "@/mixins/mobile.js";
import { getFlatRoutes } from "./common/constants/routes";

export default {
  name: "app",
  mixins: [mobile],
  created() {
    this.displayDebounce();

    //Stop error resizeObserver

    window.location.pathname = "";
    map
      .positionInfo()
      .then((ret) => {
        this.store.positionInfo = ret;
        //é mais interessante fazer uso de vuex
      })
      .catch((err) => console.log(err));
    // this.getNotifs();
    this.checkFirmware();
    alert = (msg, variant, title) => this.customAlert(msg, variant, title);

    window.wait = {
      show: () => this.$refs.dialogWait.show(),
      hide: () => this.$refs.dialogWait.hide(),
    };

    this.activeUser = cookies.get("LOGIN");
    this.userGroup = cookies.get("GROUPNAME");
    this.isAdmin = Number(cookies.get("PERMISSION")) == 1;

    this.hasManagementAccess =
      cookies.get("HAS_MANAGEMENT_ACCESS") == "true" ? true : false;
    this.hasAlertsAccess =
      cookies.get("HAS_ALERTS_ACCESS") == "true" ? true : false;
  },
  data() {
    return {
      titleNavBar: "",
      askHideMenu: false,
      activeUser: "",
      isAdmin: false,
      hasAlertsAccess: false,
      hasManagementAccess: false,
      userGroup: "",
      logo: require("./assets/icons/3v3.svg"),
      notifServerStatus: 1, //
      notifs: null,
      warning: "",
      connection: true,
      cir: true,
      dismissCountDown: 0,
      alertTitle: "",
      alertMsg: "",
      alertVariant: "dark",
      accessDeniedMessage: "",
      store: {
        positionInfo: {
          ID: null,
          UPDATE: "2018-01-01T10:00:00.000Z",
          NAME: "?",
          CITY: "?",
          STATE: "?",
          UTC: -3,
          LATITUDE: -3.834086,
          LONGITUDE: -38.476904,
          URL_MAP: "http://sig.3v3.farm",
        },
      },
    };
  },
  computed: {
    localName() {
      return this.store.positionInfo.NAME;
    },
    city() {
      return this.store.positionInfo.CITY;
    },
    state() {
      return this.store.positionInfo.STATE;
    },
    utc() {
      return this.store.positionInfo.UTC;
    },
    loginPage() {
      return this.$route.path == "/login";
    },
    viewType() {
      return this.loginPage ? "login-view" : "normal-view";
    },
    routerViewKey() {
      // "/monitoring/actuators" e "/monitoring/pir" apontam para o mesmo componente
      // (MonitEqps), então o Vue reaproveita a mesma instância ao navegar entre elas
      // (created() não roda de novo). Forçamos recriação só nesse par de rotas,
      // via key = nome da rota — nas demais, key fica undefined e o comportamento
      // padrão de reuso (ex: cliques em card que só mudam a barra/ na mesma página)
      // continua intacto.
      const name = this.$route.name;
      if (name === "monitoring-actuators" || name === "monitoring-pir") {
        return name;
      }
      return undefined;
    },
  },
  methods: {
    displayDebounce() {
      const debounce = (callback, delay) => {
        let tid;
        return function (...args) {
          const ctx = self;
          tid && clearTimeout(tid);
          tid = setTimeout(() => {
            callback.apply(ctx, args);
          }, delay);
        };
      };

      const _ = window.ResizeObserver;
      window.ResizeObserver = class ResizeObserver extends _ {
        constructor(callback) {
          callback = debounce(callback, 20);
          super(callback);
        }
      };
    },
    openAccessDeniedModal(message) {
      this.accessDeniedMessage = message;
      this.$refs.accessDeniedModal.show();
    },
    closeAccessDeniedModal() {
      this.accessDeniedMessage = "";
      this.$refs.accessDeniedModal.hide();
    },
    onChangeActiveUser() {
      this.activeUser = cookies.get("LOGIN");
      this.userGroup = cookies.get("GROUPNAME");
      this.isAdmin = Number(cookies.get("PERMISSION")) == 1;
      this.hasAlertsAccess =
        cookies.get("HAS_ALERTS_ACCESS") === "true" ? true : false;
      this.hasManagementAccess =
        cookies.get("HAS_MANAGEMENT_ACCESS") === "true" ? true : false;
    },
    logout() {
      session
        .logout()
        .then((res) => {
          console.log(res);
        })
        .catch((err) => console.log("Request failed", err));
      user.doLogout();
      this.cir = true;
      this.isAdmin = false;
      this.$router.replace({ path: "/login" });
    },
    countDownChanged(d) {
      this.dismissCountDown = d;
    },
    customAlert(msg, variant, title) {
      this.alertTitle = title ? title : "";
      this.alertMsg = msg;
      if (variant == "s") this.alertVariant = "success";
      else if (variant == "i") this.alertVariant = "info";
      else if (variant == "w") this.alertVariant = "warning";
      else if (variant == "e") this.alertVariant = "danger";
      else this.alertVariant = "dark";
      this.dismissCountDown = 10;
    },
    getNotifs() {
      status
        .getNotifications()
        .then((ret) => {
          if (Array.isArray(ret) && ret.length >= 0) {
            this.notifs = ret;
            this.notifServerStatus = 1;
          } else {
            this.notifServerStatus = 0;
            if (this.$route.name === "alerts") {
              this.$router.push("monitoring");
            }
          }
          // this.timerAlert = setTimeout(this.getNotifs, 2000);
          if (this.cir == true) this.warning = "";
          else this.warning = "Varredura desligada";
        })
        .catch((err) => {
          // console.log("App.vue -> getNotifs -> error: ", err.message);
          // this.connection = false;
          // this.warning = "Você está desconectado";
          // this.timerAlert = setTimeout(this.getNotifs, 2000);
        });
    },
    checkFirmware() {
      if (cookies.get("authToken")) {
        status
          .statusCir()
          .then((ret) => {
            if (this.connection) {
              if (!ret.firmware) this.warning = "Varredura desligada";
              else this.warning = "";
            }
            this.cir = ret.firmware;
            setTimeout(this.checkFirmware, 120000);
          })
          .catch((err) => {
            console.error(err);
            this.cir = false;
            if (this.connection) this.warning = "Varredura desligada";
            setTimeout(this.checkFirmware, 120000);
          });
      } else {
        setTimeout(this.checkFirmware, 1000);
      }
    },
  },
  watch: {
    cir() {
      if (this.cir) {
        this.warning = "";
      } else {
        this.warning = "Varredura desligada";
      }
    },
  },
};
</script>
